import { Slice, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type InquirySliceStateType = {
  items: any[] | [];
  totalItems: number;
  isTableLoading: boolean;
  page: number;
  rowsPerPage: number;
  searchValue: string;
  nextFollowupStartDate: string | null;
  nextFollowupEndDate: string | null;
  lastFollowupStartDate: string | null;
  lastFollowupEndDate: string | null;
  inquirylabel: any;
  dispositionOne: any;
  dispositionTwo: any;
  sortValue: { field: string; value: "DESC" | "ASC" };
  filterBy: {
    fieldName: string;
    value: string[];
  }[];
  dateFilter: {
    start_date: string | null;
    end_date: string | null;
  };
};

const initialState: InquirySliceStateType = {
  items: [],
  totalItems: 0,
  isTableLoading: true,
  page: 1,
  rowsPerPage: 20,
  searchValue: "",
  sortValue: { field: "createdAt", value: "DESC" },
  nextFollowupStartDate:null,
  nextFollowupEndDate:null,
  lastFollowupStartDate:null,
  lastFollowupEndDate:null,
  inquirylabel:null,
  dispositionOne:null,
  dispositionTwo:null,
  filterBy: [
    {
      fieldName: "companyName",
      value: [],
    },
    {
      fieldName: "country",
      value: [],
    },
  ],
  dateFilter: {
    start_date: null,
    end_date: null,
  },
};

const inquirySlice: Slice<InquirySliceStateType> = createSlice({
  name: "inquirySlice",
  initialState,
  reducers: {
    setItems: (state, action: PayloadAction<any[] | []>) => {
      state.items = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
      document.getElementById("scroll-top")?.scrollTo(0, 0);
    },
    setRowsPerPage: (state, action: PayloadAction<number>) => {
      state.rowsPerPage = action.payload;
      state.page = 1;
      document.getElementById("scroll-top")?.scrollTo(0, 0);
    },
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload;
      state.page = 1;
    },
    setSortValue: (
      state,
      action: PayloadAction<{ field: string; value: "DESC" | "ASC" }>
    ) => {
      state.sortValue = action.payload;
      state.page = 1;
    },
    setTotalItems: (state, action: PayloadAction<number>) => {
      state.totalItems = action.payload;
    },
    setIsTableLoading: (state, action: PayloadAction<boolean>) => {
      state.isTableLoading = action.payload;
    },
    setFilterBy: (
      state,
      action: PayloadAction<{ fieldName: string; value: string[] }[]>
    ) => {
      state.filterBy = action.payload;
      state.page = 1;
    },
    setDateFilter: (
      state,
      action: PayloadAction<{ start_date: string; end_date: string }>
    ) => {
      state.dateFilter = action.payload;
    },
    setNextFollowUpStartDate: (state, action: PayloadAction<any>) => {
      state.nextFollowupStartDate = action.payload;
    },
    setNextFollowUpEndDate: (state, action: PayloadAction<any>) => {
      state.nextFollowupEndDate = action.payload;
    },
    setLastFollowUpStartDate: (state, action: PayloadAction<any>) => {
      state.lastFollowupStartDate = action.payload;
    },
    setLastFollowUpEndDate: (state, action: PayloadAction<any>) => {
      state.lastFollowupEndDate = action.payload;
    },
    setInquiryLabel: (state, action: PayloadAction<any>) => {
      state.inquirylabel = action.payload;
      state.page = 1;
    },
    setDispositionOne: (state, action: PayloadAction<any>) => {
      state.dispositionOne = action.payload;
      state.page = 1;
    },
    setDispositionTwo: (state, action: PayloadAction<any>) => {
      state.dispositionTwo = action.payload;
      state.page = 1;
    },
  },
});

export const {
  setItems,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setSortValue,
  setTotalItems,
  setIsTableLoading,
  setDateFilter,
  setFilterBy,
  setDispositionOne ,
  setDispositionTwo ,
  setNextFollowUpStartDate ,
  setNextFollowUpEndDate ,
  setLastFollowUpStartDate ,
  setLastFollowUpEndDate ,
  setInquiryLabel
} = inquirySlice.actions;
export default inquirySlice.reducer;
